define("command-palette/command/command", ["exports", "lodash"], function (_exports, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.CommandIdentifierKey = _exports.CommandFactoryFnKey = _exports.Command = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class Command {
    constructor() {
      _defineProperty(this, "commandId", this.klass.commandId);
      _defineProperty(this, "mandatoryTerms", []);
      if (!(0, _lodash.isString)(this.klass.commandId) || !(0, _lodash.isFunction)(this.klass.create)) {
        throw new Error('Command classes must be defined with `@command` decorator');
      }
    }
    get klass() {
      return this.constructor;
    }
    execute(query) {
      return this.action(query);
    }
    isSuggested() {
      return false;
    }
    isAvailable() {
      return true;
    }
  }
  _exports.Command = Command;
  const CommandIdentifierKey = _exports.CommandIdentifierKey = 'commandId';
  const CommandFactoryFnKey = _exports.CommandFactoryFnKey = 'create';
  var _default = _exports.default = Command;
});